import { Injectable } from '@angular/core';

@Injectable()
export class CalendlyService {
  constructor() {}

  initCalendly() {
    if (window['Calendly']) {
      window['Calendly'].initBadgeWidget({
        url: 'https://calendly.com/crazycall',
        text: 'Schedule time with us',
        color: '#ec1c24',
        branding: true
      });
    } else {
      console.warn('Calendly is not load from website!');
    }
  }

  openCalendly() {
    (document.getElementsByClassName('calendly-badge-content')[0] as any).click();
  }
}
